<template>
  <label
    role="radio"
    class="flex flex-col flex-auto transition-all ring-1 ring-offset-0 w-full relative p-4 rounded-xl text-base hover:scale-[1.02] duration-150 ease-in-out"
    :class="{
      'bg-pink-100 bg-opacity-20 shadow-pink-700 shadow-md ring-pink-700 ring-2 ring-offset-1':
        value === content,
      'ring-stone-200 shadow-md': value !== content,
      'text-black cursor-pointer': !disabled,
      'text-gray-300 cursor-not-allowed shadow-none hover:transform-none': disabled,
      'has-[:focus-visible]:scale-[1.02] has-[:focus-visible]:outline has-[:focus-visible]:outline-offset-4 has-[:focus-visible]:outline-2 has-[:focus-visible]:outline-stone-700': true, //focused
    }"
    :for="`card-option-${stepNumber}-${index}`"
    :name="stepNumber"
    :id="`${name}-${index}`"
  >
    <input
      :id="`card-option-${stepNumber}-${index}`"
      type="radio"
      class="absolute top-3 right-3 opacity-0 peer"
      v-model="option"
      :value="content"
      v-if="!disabled"
      :tabindex="(index === '0' && !value) || value === content ? '0' : '-1'"
      :name="stepNumber"
    />
    <span
      class="flex bg-opacity-0 bg-pink-700 transition-all duration-300 size-5 border-2 border-stone-300 absolute top-3 right-3 rounded-full peer-checked:bg-opacity-100 peer-checked:border-pink-700"
    >
      <img
        :src="checkIcon"
        width="12"
        height="12"
        class="inline-block text-center mx-auto"
        aria-hidden="true"
      />
    </span>

    <slot></slot>
  </label>
</template>

<script setup>
import checkIcon from "@assets/images/icons/check.svg";
</script>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
    },
    index: {
      type: String,
    },
    stepNumber: {
      type: String,
    },
    value: {
      type: String | null,
    },
    content: {
      type: String | Number,
    },
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      option: this.value,
    };
  },

  watch: {
    value(value) {
      this.option = value;
    },

    option(value) {
      this.$emit("input", value);
    },
  },
};
</script>
